import { render } from "./AccumulatedPoint.vue?vue&type=template&id=7dff23a4&scoped=true"
import script from "./AccumulatedPoint.vue?vue&type=script&lang=js"
export * from "./AccumulatedPoint.vue?vue&type=script&lang=js"

import "./AccumulatedPoint.vue?vue&type=style&index=0&id=7dff23a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dff23a4"]])

export default __exports__